import { createSelector } from 'reselect';

const getState = (state) => state.directOrderRecurring.data;

const getHolidays = createSelector(getState, ({ holidays }) => holidays);
export default {
  getHolidays,
};
